(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvSmsTemplateList', function () {
            
            return {
                templateUrl: 'app/dashboard/sms-template-list.tmpl.html',
                scope: {
                    label: '@',
                    configuration: '='
                },
                controller: ['$q', '$scope', '$location', 'SMSTemplatesService', 'SMSTemplate', 'NavigationAidService', 'DialogService', 'SystemService', function ($q, $scope, $location, SMSTemplatesService, SMSTemplate, NavigationAidService, DialogService, SystemService) {
                    var drvCtrl = this;
                    drvCtrl.allTemplatesSelected = false;
                    drvCtrl.templateCount = 0;
                    drvCtrl.currentPage = 1;
                    drvCtrl.searchFields = {};
                    drvCtrl.newTemplate = newTemplate;
                    drvCtrl.deleteTemplate = deleteTemplate;
                    drvCtrl.templatePreview = templatePreview;
                    drvCtrl.updateList = updateList;
                    drvCtrl.loadCount = loadCount;
                    drvCtrl.copyTemplates = copyTemplates;
                    drvCtrl.deleteTemplates = deleteTemplates;
                    drvCtrl.close = close;
                    drvCtrl.loading = false;
                    drvCtrl.error = null;
                    drvCtrl.showDeleted = false;
                    Object.defineProperty(drvCtrl, 'selectedTemplates', {
                        get: function () {
                            return _(drvCtrl.templates)
                                .filter('Selected')
                                .value();
                        }
                    });
                    Object.defineProperty(drvCtrl, 'titleText', { get: getTitleText });

                    activate();

                    function activate() {
                        drvCtrl.searchDelay = SystemService.getSearchDelay();

                        // Watch for update on generic search text, update list if it changes
                        $scope.$watch('drvCtrl.genericSearch', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                updateList();
                            }
                        });

                        $scope.$watch('drvCtrl.showDeleted', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                updateList();
                                loadCount();
                            }
                        });

                        updateList();
                        loadCount();
                    }

                    function updateList(newPage) {
                        if (updateList.currentPromise === undefined) {
                            updateList.currentPromise = null;
                        }
                        var genericSearch = "";

                        // Page size will be supplied if it exists
                        var pageSize = null;
                        var entityTemplateId = null;
                        if (!angular.isUndefined(drvCtrl.configuration) && !angular.isUndefined(drvCtrl.configuration.ListPageSize) && drvCtrl.configuration.ListPageSize !== null) {
                            pageSize = angular.copy(drvCtrl.configuration.ListPageSize);
                        }
                        if (!angular.isUndefined(drvCtrl.configuration.EntityTemplateId) && drvCtrl.configuration.EntityTemplateId !== null) {
                            entityTemplateId = angular.copy(drvCtrl.configuration.EntityTemplateId);
                        }

                        if (!angular.isUndefined(newPage)) {
                            drvCtrl.currentPage = newPage;
                        }

                        if (!angular.isUndefined(drvCtrl.genericSearch)) {
                            genericSearch = angular.copy(drvCtrl.genericSearch);
                        }

                        drvCtrl.loading = true;
                        var getPromise = SMSTemplate.getSMSTemplates(pageSize, drvCtrl.currentPage, genericSearch, entityTemplateId)
                            .then(getTemplatesOk, getTemplatesError)
                            .then(function () {
                                drvCtrl.loading = false;
                            });

                        updateList.currentPromise = getPromise;

                        return getPromise;

                        function getTemplatesOk(data) {
                            if (getPromise === updateList.currentPromise) {
                                drvCtrl.error = null;
                                drvCtrl.allTemplatesSelected = false;
                                drvCtrl.templates = data.Items;
                                drvCtrl.templateCount = data.ItemCount;
                            }
                            else {
                                return $q.reject();
                            }
                        }

                        function getTemplatesError(response) {
                            if (getPromise === updateList.currentPromise) {
                                drvCtrl.error = response;
                            }
                            else {
                                return $q.reject();
                            }
                        }
                    }

                    function loadCount() {
                        return SMSTemplatesService.count(drvCtrl.showDeleted)
                            .then(loadCountOk, loadCountError);

                        function loadCountOk(count) {
                            drvCtrl.totalCount = count;
                        }

                        function loadCountError(response) {
                        }
                    }

                    function deleteTemplate(template) {
                        template.delete()
                            .then(deleteTemplateOk, deleteTemplateError);

                        function deleteTemplateOk(success) {
                            drvCtrl.updateList();
                            drvCtrl.loadCount();
                        }

                        function deleteTemplateError(response) {
                            if (!_.isNil(response)) {
                                DialogService.error('Error deleting SMS Template', response);
                            }
                        }
                    }

                    function templatePreview(template) {
                        var preview = '';
                        preview = template.data.Description;

                        return preview;
                    }

                    /**
                     * Redirects to the new sms template route
                     */
                    function newTemplate() {
                        var url = '/smstemplates/new';

                        if (!angular.isUndefined(drvCtrl.configuration.EntityTemplateId) && drvCtrl.configuration.EntityTemplateId !== null) {
                            url += '?entityTemplateId=' + drvCtrl.configuration.EntityTemplateId;
                        }

                        $location.url(url);
                    }

                    /**
                     * Ensure at least one sms template is selected.
                     * Displays a dialog 'No sms templates were selected' if no sms templates are selected.
                     * @return {bool} true if at least one sms template is selected, else false
                     */
                    function ensureTemplatesSelection() {
                        if (drvCtrl.selectedTemplates.length === 0) {
                            DialogService.alert('No SMS Templates were selected');
                            return false;
                        } else {
                            return true;
                        }
                    }

                    /**
                     * Copy the sms templates selected in the list.
                     */
                    function copyTemplates() {
                        var selectedTemplateIds = _.map(drvCtrl.selectedTemplates, 'data.Id');
                        var templateLabel = 'SMS Template';
                        if (selectedTemplateIds.length > 1) {
                            templateLabel += 's';
                        }

                        if (ensureTemplatesSelection()) {
                            DialogService
                                .confirm('Copy the ' + selectedTemplateIds.length + ' selected ' + templateLabel + '?', 'Copy ' + templateLabel + ' confirm')
                                .then(copyTemplatesConfirmed);
                        }

                        function copyTemplatesConfirmed() {
                            return SMSTemplatesService.multiCopy(selectedTemplateIds)
                               .then(copyOk, copyError);
                        }

                        function copyOk() {
                            updateList();
                            loadCount();
                        }

                        function copyError(response) {
                            DialogService.error('Error copying ' + templateLabel, response);
                            updateList();
                        }
                    }

                    /**
                     * Delete the sms templates selected in the list.
                     */
                    function deleteTemplates() {
                        var selectedTemplateIds = _.map(drvCtrl.selectedTemplates, 'data.Id');
                        var templateLabel = 'SMS Template';
                        if (selectedTemplateIds.length > 1) {
                            templateLabel += 's';
                        }

                        if (ensureTemplatesSelection()) {
                            return DialogService
                                .confirm('Delete the ' + selectedTemplateIds.length + ' selected ' + templateLabel + '?', 'Delete ' + templateLabel + ' confirm')
                                .then(deleteTemplatesConfirmed);
                        }

                        function deleteTemplatesConfirmed() {
                            SMSTemplatesService.multiDelete(selectedTemplateIds)
                                .then(deleteTemplatesOk, deleteTemplatesError);
                        }

                        function deleteTemplatesOk(success) {
                            updateList();
                            loadCount();
                        }

                        function deleteTemplatesError(response) {
                            DialogService.error('Error deleting ' + templateLabel, response);
                        }
                    }

                    /**
                     * When the view is 'closed' navigation to a previous page should occur.
                     */
                    function close() {
                        NavigationAidService.goBack();
                    }

                    /**
                     * Gets the view title
                     *
                     * @returns {string}
                     */
                    function getTitleText() {
                        var result = '';

                        if (drvCtrl.showDeleted === true) {
                            result += 'Deleted ';
                        }

                        result += 'SMS Templates';

                        return result;
                    }
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    configuration: '=',
                    viewMode: '<?',
                    subViewMode: '<?'
                }
            };
        });
})();